// extracted by css-extract-rspack-plugin
export default {"container":"container-Y5gFld","input":"input-Vt4rMm"};